import { AnimatePresence } from 'framer-motion';
import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { ReduxState } from '../../redux';
import { LocationState } from '../../topup-src/utils/types';
import { checkSegmentTrackPageCall, getSegmentPageName } from '../../utils/common';
import { MAIN_ROUTES } from '../../utils/constants';
import { SEGMENT_ACTIONS } from '../../utils/constants/SegmentActionConstants';
import useSegment from '../../utils/hooks/useSegment';
import { AuthRoute } from '../../utils/RouteGuards';
import EmptyPageLoader from '../atoms/EmptyPageLoader';
import CookiePopupWrapper from '../containers/CookiePopupWrapper';

const SPAContainer = React.lazy(() => import('./SPAContainer'));
const LoginContainer = React.lazy(() => import('./LoginContainer'));

const MainRouter: React.FunctionComponent = () => {
    const location = useLocation<LocationState>();
    const trackPage = useSegment('page');
    const userId = useSelector((state: ReduxState) => state.user?.userData?.data?.userId);

    React.useEffect(() => {
        if (checkSegmentTrackPageCall(location.pathname)) {
            const currentPageAction = SEGMENT_ACTIONS.PAGE[getSegmentPageName(location.pathname) as any];
            const refPageAction = SEGMENT_ACTIONS.PAGE[getSegmentPageName(location?.state?.previousUrl) as any];
            trackPage({
                name: currentPageAction.name,
                properties: {
                    page_url:
                        (currentPageAction.properties?.page_url as (path: string) => string)(location.pathname) || '',
                    page_id:
                        (currentPageAction.properties?.page_id as (path: string) => string)(location.pathname) || '',
                    page_title: currentPageAction.properties?.page_title,
                    login_status: (currentPageAction.properties?.login_status as (loginStatus: boolean) => boolean)(
                        userId ? true : false
                    ),
                    referrer_page_title:
                        (currentPageAction.properties?.referrer_page_title as (refPage: string) => string)(
                            refPageAction?.name
                        ) || '',
                    referrer_page_url:
                        (currentPageAction.properties?.referrer_page_url as (refUrl: string) => string)(
                            location?.state?.previousUrl
                        ) || ''
                }
            });
        }
    }, [location.pathname]);
    return (
        <Suspense fallback={<EmptyPageLoader />}>
            <CookiePopupWrapper />
            <AnimatePresence>
                <Switch location={location} key={location.pathname}>
                    <Route path={MAIN_ROUTES.login}>
                        <LoginContainer />
                    </Route>
                    <AuthRoute path={MAIN_ROUTES.app} Component={SPAContainer} />
                    <Redirect from={'/'} to={MAIN_ROUTES.app} />
                </Switch>
            </AnimatePresence>
        </Suspense>
    );
};

export default MainRouter;
